<template>
  <v-tooltip :disabled="!overLimit" bottom>
    <template #activator="{on}">
      <v-text-field
        v-on="on"
        :error-messages="errorMessages"
        :hint="overLimit ? $t('components.amountInput.overLimit') : null"
        :label="contextLabel"
        :rules="computedRules"
        :suffix="suffix"
        v-model="computedModel"
        :prepend-icon="prependIcon"
        :placeholder="placeholder"
        :readonly="readonly"
        :persistent-hint="overLimit"
        :loading="overLimit"
      >
        <template #progress>
          <v-progress-linear color="error" height="7" v-if="overLimit" value="100" absolute />
        </template>
      </v-text-field>
    </template>
    {{ $t("components.amountInput.overLimit") }}
  </v-tooltip>
</template>

<script>
export default {
  name: "AmountInput",
  props: {
    readonly: {
      default: false,
      required: false
    },
    label: {
      default: false,
      required: false
    },
    model: {
      required: true
    },
    errorMessages: {
      default: () => [],
      required: false,
      type: Array
    },
    rules: {
      default: () => [],
      required: false
    },
    suffix: {
      default: null,
      required: false
    },
    overLimit: {
      default: false,
      required: false
    },
    prependIcon: {
      default: null,
      required: false
    },
    placeholder: {
      default: null,
      required: false
    }
  },

  computed: {
    contextLabel() {
      if (this.label === false) {
        return this.$t("components.amountInput.label");
      }
      return this.label;
    },
    computedModel: {
      set: function(value) {
        value = value.replace(" ", "");
        value = value.replace(",", ".");
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    computedRules() {
      let rule = [() => !isNaN(this.model) || this.$t("global.error.notANumber"), () => this.model < 99999999 || this.$t("global.error.outOfRange")];
      for (let r of this.rules) {
        rule.push(r);
      }
      return rule;
    }
  },
  beforeDestroy() {
    //this.$emit('update:model', null);
  }
};
</script>

<style scoped />
